import axios from 'axios'

const API_BASE = process.env.VUE_APP_TICKETS_API_URL || 'https://erp.intrare.app'
const API_KEY = process.env.VUE_APP_TICKETS_API_KEY

const instance = axios.create({
  baseURL: API_BASE,
  headers: {
    'X-API-Key': API_KEY,
    'Content-Type': 'application/json'
  }
})

export const ticketsService = {
  async getAreas () {
    try {
      const response = await instance.get('/api/areas')
      return response.data
    } catch (error) {
      console.error('Error al obtener áreas:', error)
      throw error
    }
  },

  async getAllTickets (limit = 100) {
    try {
      const response = await instance.get(`/api/tickets?limit=${limit}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener tickets:', error)
      throw error
    }
  },

  async getTicketsByEmail (email, limit = 50) {
    try {
      const response = await instance.get(`/api/tickets?email=${email}&limit=${limit}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener tickets del usuario:', error)
      throw error
    }
  },

  async createTicket (data) {
    try {
      const response = await instance.post('/api/tickets', {
        title: data.title,
        description: data.description || '',
        area_id: data.area_id,
        client_name: data.client_name || '',
        client_email: data.client_email || '',
        client_phone: data.client_phone || ''
      })
      return response.data
    } catch (error) {
      console.error('Error al crear ticket:', error)
      throw error
    }
  }
}

export default ticketsService
